'use strict';exports.__esModule = true;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var checkIsUserCanEditProperty = function checkIsUserCanEditProperty(propertyId, userId, userProperties) {
  var userProps = (0, _get2.default)(userProperties, 'data.data') || [(0, _get2.default)(userProperties, 'editedProperty') || {}];

  if (!userProps || !propertyId) {
    return false;
  }

  return userProps.some(
  function (_ref) {var staffId = _ref.staff_id,propertyUserId = _ref.user_id,id = _ref.id;return (
      propertyId === id && (
      propertyUserId === userId || staffId === userId));});

};exports.default =

checkIsUserCanEditProperty;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/checkUserIsAllowedToEditProperty.js
// module id = 3147
// module chunks = 0